module.exports = __webpack_public_path__ + "static/media/two-men-walking.478004a2.png";